import {
    GET_MENU_MERCHANT_DATA,
    GET_MENU_MERCHANT_DATA_SUCCESS,
    GET_MENU_MERCHANT_DATA_FAILED,
    SIGNOUT_USER_SUCCESS,
    BACK_TO_LOGIN,
} from "../../constants/ActionTypes";


const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    menuList: [],
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_MENU_MERCHANT_DATA: {
            return {
                ...state,
                loader: true,
                showMessage: false,
                alertMessage: '',
                menuList : [],
            }
        }



        // Response
        case GET_MENU_MERCHANT_DATA_SUCCESS: {
            return {
                ...state,
                loader: false,
                menuList: action.payload.menu
            }
        }

        case GET_MENU_MERCHANT_DATA_FAILED: {
            console.log('GET_MENU_MERCHANT_DATA_FAILED', action.payload);
            return {
                ...state,
                loader: false,
                alertMessage: action.payload,
                showMessage: true
            }
        }

        case SIGNOUT_USER_SUCCESS:
        case BACK_TO_LOGIN: {
            return INIT_STATE;
        }

        default:
            return state;
    }
}
